//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    body: String,
    bulletListTitle: String,
    bulletListItems: Array
  }
}
